<!-- MasterBookのタイトル・コメント -->
<template>
  <div>
    <!-- チケット名 masterBookSetがある場合は、masterBookSet.nameを表示-->
    <MbNameDisp :name="masterBookSet ? masterBookSet.name : masterBook.name" />
    <!-- チケット名 -->

    <!-- コメント-->
    <MbCommentDisp :comment="masterBook.comment" />
    <!-- コメント-->
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";

export default {
  name: "TheMbNameAndComment",
  setup() {
    const store = useStore();
    const masterBook = computed(() => store.getters["ticketing/masterBook"]);
    const masterBookSet = computed(
      () => store.getters["ticketing/masterBookSet"]
    );

    return {
      masterBook,
      masterBookSet,
    };
  },
};
</script>
